module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_7016.3241fcfc.png";